'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var timeline_1 = require("../timeline");
/**
 * Component to show a selection box (like on windows desktop)
 */
var SelectBox = /** @class */ (function (_super) {
    __extends(SelectBox, _super);
    function SelectBox(props) {
        var _this = _super.call(this, props) || this;
        _this.curX = 0;
        _this.curY = 0;
        _this.startX = 0;
        _this.startY = 0;
        return _this;
    }
    /**
     * Create the selection box
     * @param {number} x Starting x coordinate for selection box
     * @param {number} y Starting y coordinate for selection box
     */
    SelectBox.prototype.start = function (x, y) {
        this.startX = x;
        this.startY = y;
        this.curX = x;
        this.curY = y;
    };
    /**
     * Update the selection box as the mouse moves
     * @param {number} x The current X coordinate of the mouse
     * @param {number} y The current Y coordinate of the mouse
     */
    SelectBox.prototype.move = function (x, y) {
        this.curX = x;
        this.curY = y;
        this.forceUpdate();
    };
    /**
     * Generally on mouse up.
     * Finish the selection box and return the rectangle created
     * @returns {Object} The selection rectangle
     * @property {number} top The top y coordinate
     * @property {number} left The left x coordinate
     * @property {number} width The width of the box
     * @property {number} height The height of the box
     */
    SelectBox.prototype.end = function () {
        var _a = this, startX = _a.startX, startY = _a.startY, curX = _a.curX, curY = _a.curY;
        var left = Math.min(startX, curX);
        var top = Math.min(startY, curY);
        var width = Math.abs(startX - curX);
        var height = Math.abs(startY - curY);
        var toReturn = { left: left, top: top, width: width, height: height };
        this.startX = 0;
        this.startY = 0;
        this.curX = 0;
        this.curY = 0;
        this.forceUpdate();
        return toReturn;
    };
    /**
     * Check if the selection box is created.
     * @return {boolean}
     */
    SelectBox.prototype.isStart = function () {
        return this.startX != 0 && this.startY != 0 && this.curX != 0 && this.curY != 0;
    };
    /**
     * @ignore
     */
    SelectBox.prototype.render = function () {
        var _a = this, startX = _a.startX, startY = _a.startY, curX = _a.curX, curY = _a.curY;
        var left = Math.min(startX, curX);
        var top = Math.min(startY, curY);
        var width = Math.abs(startX - curX);
        var height = Math.abs(startY - curY);
        var style = { left: left, top: top, width: width, height: height };
        return ((0, jsx_runtime_1.jsx)("div", { "data-testid": 'r9k1_' + timeline_1.timelineTestids.selector, className: "rct9k-selector-outer ".concat(this.props.className), style: style }));
    };
    return SelectBox;
}(react_1.default.Component));
exports.default = SelectBox;
//# sourceMappingURL=selector.js.map